import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrash, faCopy, faEnvelope, faPersonDigging } from '@fortawesome/free-solid-svg-icons';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import { Modal } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import WizardIcon from '../../assets/ic_wizard.png';
import { TailSpin } from  'react-loader-spinner';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import './eticket.css';
import FloatingSaveButton from '../../components/FloatingSaveButton';
import { ListItemText, FormControl, InputLabel, MenuItem, Select, Switch, TextField, useTheme, Tabs, Tab, Tooltip as MuiTooltip, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 2 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
  
function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}

function LinkCell (props) {
    const route = props.route || "eticket";
    if(props.onClick) {
        return (<span onClick={props.onClick} style={{ width: '100%', height: '100%', alignContent: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer', color: '#1976d2'}}>{props.children}</span>)
    }
    return (<Link to={"/"+props.lang+"/"+route+"/"+props.id+"/"+props.element} style={{ width: '100%', height: '100%', alignContent: 'center', alignItems: 'center', display: 'flex'}}>{props.children}</Link>)
}

const StyledModal = styled(Modal)`
    position: fixed;
    text-align: center;
    z-index: 1300;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    `;

const Backdrop = styled('div')`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    `;

const style = {
    bgcolor: 'background.paper',
    border: '0px solid #000',
    borderRadius: 6,
    p: 2,
    px: 4,
    pb: 3,
    };

const EticketScreen = (props) =>  {
    const isSftUser = props.login.sft_status !== "0";
    const getInitialTab = () => {
        const stored = sessionStorage.getItem('eticketActiveTab');
        const storedApi = sessionStorage.getItem('eticketActiveTabApi');
        if (stored !== null && storedApi === props.api) {
            return parseInt(stored, 10);
        }
        return 0;
    };
    const [value, setValue] = useState(getInitialTab);
    const [statsLoading, setStatsLoading] = useState(true);
    const [usageStats, setUsageStats] = useState([]);
    const [storeStats, setStoreStats] = useState([]);
    const [storeNames, setStoreNames] = useState ([]);
    const [stores, setStores] = useState([]);
    const [pos, setPos] = useState ([]);
    const [corps, setCorps] = useState([]);
    const [selectedStore, setSelectedStore] = useState([]);
    const [selectedPos, setSelectedPos] = useState([]);
    const [selectedCorp, setSelectedCorp] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState("");
    const [modalId, setModalId] = useState("0");
    const [modalElement, setModalElement] = useState({});
    const [loading, setLoading] = useState(true);
    const [active, setActive] = useState(false);
    const [activeEinvoice, setActiveEinvoice] = useState(false);
    const [activeEcustom, setActiveEcustom] = useState(false);
    const [attachments, setAttachments] = useState(false);
    const [attachmentsEinvoice, setAttachmentsEinvoice] = useState(false);
    const [attachmentsEcustom, setAttachmentsEcustom] = useState(false);
    // Default templates for simulated global rows
    const [defaultEticket, setDefaultEticket] = useState(null);
    const [defaultEinvoice, setDefaultEinvoice] = useState(null);
    const [defaultEcustom, setDefaultEcustom] = useState(null);
    // SMTP settings
    const [smtpOptions, setSmtpOptions] = useState([]);
    const [smtpPreset, setSmtpPreset] = useState("-1");
    const [smtpPresetId, setSmtpPresetId] = useState("0");
    const [smtpName, setSmtpName] = useState("");
    const [smtpHost, setSmtpHost] = useState("");
    const [smtpUser, setSmtpUser] = useState("");
    const [smtpPass, setSmtpPass] = useState("");
    const [smtpPort, setSmtpPort] = useState("");
    const [smtpSSL, setSmtpSSL] = useState(false);
    const [validateSmtpLoader, setValidateSmtpLoader] = useState(false);
    const [showSmtpPass, setShowSmtpPass] = useState(false);
    const [lists, setLists] = useState([]);
    const [mainId, setMainId] = useState("0");
    // E-invoice state
    const [listsEinvoice, setListsEinvoice] = useState([]);
    const [loadingEinvoice, setLoadingEinvoice] = useState(true);
    const [mainIdEinvoice, setMainIdEinvoice] = useState("0");
    // E-custom state
    const [listsEcustom, setListsEcustom] = useState([]);
    const [loadingEcustom, setLoadingEcustom] = useState(true);
    const [mainIdEcustom, setMainIdEcustom] = useState("0");
    const [activatedAtEticket, setActivatedAtEticket] = useState(null);
    const [activatedAtEinvoice, setActivatedAtEinvoice] = useState(null);
    const [activatedAtEcustom, setActivatedAtEcustom] = useState(null);
    const [dbVersion, setDbVersion] = useState(0);
    const [testEmail, setTestEmail] = useState(props.login.login);
    const [testTicketType, setTestTicketType] = useState("RECEIPT");
    const [testTicketLanguage, setTestTicketLanguage] = useState("NL");
    const [testTicket, setTestTicket] = useState("");
    const [testData, setTestData] = useState({receipt: "", reservation: "", offer: "", cust_order: "", client_id: "", db_id: ""});
    const [testInvoiceType, setTestInvoiceType] = useState("faktuur");
    const [testInvoiceCorp, setTestInvoiceCorp] = useState("");
    const [testInvoiceId, setTestInvoiceId] = useState("");
    const [testEcustomSubject, setTestEcustomSubject] = useState("");
    const [testEcustomBody, setTestEcustomBody] = useState("");
    const [testEcustomAttachments, setTestEcustomAttachments] = useState([]);
    const initialGrid = getCookie("initialStateEticket") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateEticket"));
    const gridColumns = [
        {
            field: 'name',
            headerName: props.t('name'),
            minWidth: 300,
            headerAlign: 'left',
            align: 'left',        
            display: 'flex',
            renderCell: (params) => {
                    return <LinkCell element={params.row.key} id={params.row.mainId} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEticket : undefined} ><span>{params.row.name}</span></LinkCell>
                }
        },
        {
            field: 'store',
            headerName: props.t('store'),
            minWidth: 50,
            maxWidth: 100,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                    return <LinkCell element={params.row.key} id={params.row.mainId} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEticket : undefined} ><span>{params.row.store_id}</span></LinkCell>
                }
        },
        {
            field: 'POS',
            headerName: props.t('pos_id'),
            minWidth: 50,
            maxWidth: 100,
            align: 'left',
            headerAlign: 'left',
            display: 'flex',
            renderCell: (params) => {
                    return <LinkCell element={params.row.key} id={params.row.mainId} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEticket : undefined} ><span>{params.row.pos_id}</span></LinkCell>
                }
        },
        {
            field: 'edit',
            headerName: props.t('edit'),
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                const handleClick = params.row.isSimulated
                    ? createAndNavigateEticket
                    : () => navigate("/"+props.lang+"/eticket/"+params.row.mainId+"/"+params.row.key);
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={handleClick} >
                    <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                </Button>;
            }
        },
        {
            field: 'copy',
            headerName: props.t('copy'),
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDuplicate(params.row.mainId, params.row.key)}} ><FontAwesomeIcon icon={faCopy} color={Colors.def_grey} size="2x" /></Button>
            }
        },
        {
            field: 'delete',
            headerName: props.t('delete'),
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return ((params.row.pos_id !== "0000" || params.row.store_id !== "00" || ((props.login.sft_group === "ADMIN" || props.login.sft_group === "SUPER") && params.row.listSize === 1))) ? <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDeleteService(params.row.mainId, params.row.key)}} >
                    <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                </Button> : <div></div>;
            }
        },
        {
            field: 'test',
            headerName: "Test",
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
              return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{testMail(params.row.mainId, params.row)}} ><FontAwesomeIcon icon={faEnvelope} color={Colors.def_grey} size="2x" /></Button>
              }
      },
      ];

    // E-invoice grid (corp-based, not store/pos)
    const initialGridEinvoice = getCookie("initialStateEinvoice") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateEinvoice"));
    const gridColumnsEinvoice = [
        {
            field: 'name',
            headerName: props.t('name'),
            minWidth: 300,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell route="einvoice" element={params.row.key} id={params.row.mainIdEinvoice} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEinvoice : undefined}><span>{params.row.name}</span></LinkCell>
            }
        },
        {
            field: 'corp',
            headerName: 'Corp',
            minWidth: 100,
            maxWidth: 150,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell route="einvoice" element={params.row.key} id={params.row.mainIdEinvoice} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEinvoice : undefined}><span>{params.row.corp_id}</span></LinkCell>
            }
        },
        {
            field: 'edit',
            headerName: props.t('edit'),
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                const handleClick = params.row.isSimulated
                    ? createAndNavigateEinvoice
                    : () => navigate("/"+props.lang+"/einvoice/"+params.row.mainIdEinvoice+"/"+params.row.key);
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={handleClick} >
                    <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                </Button>;
            }
        },
        {
            field: 'copy',
            headerName: props.t('copy'),
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDuplicateEinvoice(params.row.mainIdEinvoice, params.row.key)}} >
                    <FontAwesomeIcon icon={faCopy} color={Colors.def_grey} size="2x" />
                </Button>;
            }
        },
        {
            field: 'delete',
            headerName: props.t('delete'),
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return ((params.row.corp_id !== "00" || (isSftUser && params.row.listSize === 1))) ?
                    <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDeleteService(params.row.mainIdEinvoice, params.row.key)}} >
                        <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                    </Button> : <div></div>;
            }
        },
        {
            field: 'test',
            headerName: "Test",
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
              return  <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{testMailEinvoice(params.row.mainIdEinvoice, params.row)}} ><FontAwesomeIcon icon={faEnvelope} color={Colors.def_grey} size="2x" /></Button>
              }
        },
    ];
    const apiRefEinvoice = useGridApiRef();

    // E-custom grid
    const initialGridEcustom = getCookie("initialStateEcustom") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateEcustom"));
    const gridColumnsEcustom = [
        {
            field: 'name',
            headerName: props.t('name'),
            minWidth: 300,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell route="ecustom" element={params.row.key} id={params.row.mainIdEcustom} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEcustom : undefined}><span>{params.row.name}</span></LinkCell>
            }
        },
        {
            field: 'store',
            headerName: props.t('store'),
            minWidth: 50,
            maxWidth: 100,
            headerAlign: 'left',
            align: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell route="ecustom" element={params.row.key} id={params.row.mainIdEcustom} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEcustom : undefined}><span>{params.row.store_id}</span></LinkCell>
            }
        },
        {
            field: 'POS',
            headerName: props.t('pos_id'),
            minWidth: 50,
            maxWidth: 100,
            align: 'left',
            headerAlign: 'left',
            display: 'flex',
            renderCell: (params) => {
                return <LinkCell route="ecustom" element={params.row.key} id={params.row.mainIdEcustom} lang={params.row.lang} theme={params.row.theme} onClick={params.row.isSimulated ? createAndNavigateEcustom : undefined}><span>{params.row.pos_id}</span></LinkCell>
            }
        },
        {
            field: 'edit',
            headerName: props.t('edit'),
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                const handleClick = params.row.isSimulated
                    ? createAndNavigateEcustom
                    : () => navigate("/"+props.lang+"/ecustom/"+params.row.mainIdEcustom+"/"+params.row.key);
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={handleClick} >
                    <FontAwesomeIcon icon={faPencilAlt} color={Colors.def_orange} size="2x" />
                </Button>;
            }
        },
        {
            field: 'test',
            headerName: props.t('test'),
            minWidth: 60,
            maxWidth: 60,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{testMailEcustom(params.row.mainIdEcustom, params.row)}} >
                    <FontAwesomeIcon icon={faEnvelope} color={Colors.def_grey} size="2x" />
                </Button>;
            }
        },
        {
            field: 'delete',
            headerName: props.t('delete'),
            minWidth: 60,
            maxWidth: 100,
            align: 'center',
            headerAlign: 'center',
            display: 'flex',
            renderCell: (params) => {
                if(params.row.isSimulated) return <div></div>;
                return ((params.row.pos_id !== "0000" || params.row.store_id !== "00" || (isSftUser && params.row.listSize === 1))) ?
                    <Button style={{color: (props.theme === 'dark' ? Colors.dark_text : Colors.light_text), height:"100%", borderRadius: "50%" }} onClick={()=>{onDeleteService(params.row.mainIdEcustom, params.row.key)}} >
                        <FontAwesomeIcon icon={faTrash} color={Colors.def_red} size="2x" />
                    </Button> : <div></div>;
            }
        },
    ];
    const apiRefEcustom = useGridApiRef();

    let navigate = useNavigate();
    const theme = useTheme();

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        sessionStorage.setItem('eticketActiveTab', newValue);
        sessionStorage.setItem('eticketActiveTabApi', props.api);
    };

    const onDuplicate = (id, element) => {
        setModalTitle("Duplicate target");
        setModalId(id);
        setModalElement(element);
        setModalContent("duplicate");
        setModalOpen(true);
    }

    const duplicateCall = (id, element) => {
        setModalOpen(false);
        let target = generateTargetJson();
        if(SftGlobalData.debug){
            console.log("stores", selectedStore);
            console.log("pos", selectedPos);
            console.log("target", target)
        }

        setLoading(true);
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            id: id,
            key: props.api,
            element: element,
            stores: target.stores,
            pos: target.pos
        }

        SftGlobalData.post('eticket&action=duplicate', postData).then(response => {
            if(response.status === 200){
                fetchHeaders();
                setSelectedStore([]);
                setSelectedPos([]);
            }
        });
    }

    const generateTargetJson = () => {
        let storesData = ""; 
        selectedStore.forEach(element => {
            if(storesData !== ""){
                storesData += ",";
            }
            storesData += element.substring(0,2);
        });

        let posData = ""; 
        selectedPos.forEach(element => {
            if(posData !== ""){
                posData += ",";
            }
            posData += element.substring(0,4);
        });

        return {stores: storesData, pos: posData};
    }

    const onDuplicateEinvoice = (id, element) => {
        setModalTitle("Duplicate target");
        setModalId(id);
        setModalElement(element);
        setModalContent("duplicateEinvoice");
        setModalOpen(true);
    }

    const duplicateCallEinvoice = (id, element) => {
        setModalOpen(false);
        let corpsData = generateCorpsTarget();
        if(SftGlobalData.debug){
            console.log("corps", selectedCorp);
            console.log("corpsData", corpsData);
        }

        setLoadingEinvoice(true);
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            id: id,
            key: props.api,
            element: element,
            corps: corpsData
        }

        SftGlobalData.post('eticket&action=duplicate', postData).then(response => {
            if(response.status === 200){
                fetchHeaders();
                setSelectedCorp([]);
            }
        });
    }

    const generateCorpsTarget = () => {
        let corpsData = "";
        selectedCorp.forEach(element => {
            if(corpsData !== ""){
                corpsData += ",";
            }
            // Extract the corp ID from the selected value (format: "id - name")
            corpsData += element.split(" - ")[0];
        });
        return corpsData;
    }

    const handleChangeCorp = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedCorp(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const apiRef = useGridApiRef();
        
        
        useEffect(()=>{
            //console.log("adding subscriptions");
            try{
                apiRef.current.subscribeEvent(
                    'columnOrderChange',
                    ()=>{visibilityChangedHandler();},
                );
            }catch(ex){
        
            }
        }, [apiRef]);


        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            //console.log("cookie", cname + "=" + cvalue + ";" + expires + ";path=/");
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    
        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) === ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "{}";
        }
    
        const visibilityChangedHandler = () => {
            let temp = apiRef.current.exportState();
            if(typeof temp.columns.columnVisibilityModel === "undefined"){
                temp.columns.columnVisibilityModel = {};
            }
            try{
                temp.preferencePanel.open = false;
            }catch(e){
        
            }
            try{
                delete temp.pagination;
            }catch(e){
                console.error(e);
            }
            setCookie("initialStateEticket", JSON.stringify(temp), 100000);
        }

    useEffect(() => {
        props.changeScreen('Eticket');
        const storedApi = sessionStorage.getItem('eticketActiveTabApi');
        if (storedApi !== props.api) {
            const defaultTab = 0;
            setValue(defaultTab);
            sessionStorage.setItem('eticketActiveTab', defaultTab);
            sessionStorage.setItem('eticketActiveTabApi', props.api);
        }
        if(props.api){
            fetchDbVersion();
            fetchHeaders();
            fetchStores();
            fetchDefaults();
        }
     },[props.api]);

    const fetchDefaults = () => {
        // Set hardcoded fallback defaults so simulated rows always appear
        setDefaultEticket(prev => prev || { id: null, key: "0", name: "Global", store_id: "00", pos_id: "0000" });
        setDefaultEinvoice(prev => prev || { id: null, key: "0", name: "Global", corp_id: "00" });
        setDefaultEcustom(prev => prev || { id: null, key: "0", name: "Global", store_id: "00", pos_id: "0000" });

        // Enrich with real data from API if available
        let postData = {
            key: props.api
        }
        SftGlobalData.post('eticket&action=fetchDefaults', postData).then(response => {
            if(response.status === 200 && response.data?.length > 0){
                response.data.forEach(def => {
                    const serviceType = String(def.service_type).toUpperCase();
                    const settingsObj = def.settings || {};
                    const firstKey = Object.keys(settingsObj)[0];
                    const firstSetting = firstKey !== undefined ? settingsObj[firstKey] : null;

                    if((serviceType === 'ETICKET') && firstSetting) {
                        setDefaultEticket({
                            id: def.id,
                            key: firstKey,
                            name: "Global",
                            store_id: firstSetting.store_id || "00",
                            pos_id: firstSetting.pos_id || "0000"
                        });
                    } else if(serviceType === 'INVOICE' && firstSetting) {
                        setDefaultEinvoice({
                            id: def.id,
                            key: firstKey,
                            name: "Global",
                            corp_id: firstSetting.corp_id || "00"
                        });
                    } else if(serviceType === 'CUSTOM' && firstSetting) {
                        setDefaultEcustom({
                            id: def.id,
                            key: firstKey,
                            name: "Global",
                            store_id: firstSetting.store_id || "00",
                            pos_id: firstSetting.pos_id || "0000"
                        });
                    }
                });
            }
        });
    }

    const createAndNavigateEticket = () => {
        if(!defaultEticket) return;
        setLoading(true);
        let postData = {
            key: props.api,
            service_type: 'ETICKET',
            settings: defaultEticket.id ? undefined : [{ store_id: "00", pos_id: "0000", mail_settings: {}, layout: {} }],
            active: 0,
            enable_attachments: 0,
            default_id: defaultEticket.id
        }
        SftGlobalData.post('eticket&action=createFromDefault', postData).then(response => {
            setLoading(false);
            if(response.status === 200 && response.data){
                fetchHeaders();
                navigate("/"+props.lang+"/eticket/"+response.data.id+"/"+response.data.key);
            }
        }).catch(() => {
            setLoading(false);
        });
    }

    const createAndNavigateEinvoice = () => {
        if(!defaultEinvoice) return;
        setLoadingEinvoice(true);
        let postData = {
            key: props.api,
            service_type: 'INVOICE',
            settings: defaultEinvoice.id ? undefined : [{ corp_id: "00", mail_settings: {}, layout: {} }],
            active: 0,
            enable_attachments: 0,
            default_id: defaultEinvoice.id
        }
        SftGlobalData.post('eticket&action=createFromDefault', postData).then(response => {
            setLoadingEinvoice(false);
            if(response.status === 200 && response.data){
                fetchHeaders();
                navigate("/"+props.lang+"/einvoice/"+response.data.id+"/"+response.data.key);
            }
        }).catch(() => {
            setLoadingEinvoice(false);
        });
    }

    const createAndNavigateEcustom = () => {
        if(!defaultEcustom) return;
        setLoadingEcustom(true);
        let postData = {
            key: props.api,
            service_type: 'CUSTOM',
            settings: defaultEcustom.id ? undefined : [{ store_id: "00", pos_id: "0000", mail_settings: {}, layout: {} }],
            active: 0,
            enable_attachments: 0,
            default_id: defaultEcustom.id
        }
        SftGlobalData.post('eticket&action=createFromDefault', postData).then(response => {
            setLoadingEcustom(false);
            if(response.status === 200 && response.data){
                fetchHeaders();
                navigate("/"+props.lang+"/ecustom/"+response.data.id+"/"+response.data.key);
            }
        }).catch(() => {
            setLoadingEcustom(false);
        });
    }

    const fetchStores = () => {
        SftGlobalData.post('sftData', {key: props.api, type: "stores"}).then(response => {
            setStores(response.data.data);
        });

        SftGlobalData.post('sftData', {key: props.api, type: "pos"}).then(response => {
            setPos(response.data.data);
        });

        SftGlobalData.post('peppol&action=fetch', {key: props.api}).then(response => {
            setCorps(response.data);
        });
    }

    const fetchSmtpOptions = () => {
        // Fetch saved SMTP settings and scheduler presets in parallel
        Promise.all([
            SftGlobalData.post('eticket&action=fetchSmtp', {key: props.api}),
            SftGlobalData.post('client&action=fetchSchedulerSMTP', {key: props.api})
        ]).then(([savedResponse, presetsResponse]) => {
            const servers = presetsResponse.data?.servers || [];
            setSmtpOptions(servers);

            // Load saved SMTP settings
            const savedSmtp = savedResponse.data?.[0];
            if(savedSmtp){
                const isPreset = savedSmtp.smtp_preset_id && savedSmtp.smtp_preset_id.toString() !== "0";
                setSmtpName(savedSmtp.name || "");
                setSmtpHost(savedSmtp.host || "");
                setSmtpUser(isPreset ? "**********" : (savedSmtp.user || ""));
                setSmtpPass(isPreset ? "**********" : (savedSmtp.pass || ""));
                setSmtpPort(savedSmtp.port?.toString() || "");
                setSmtpSSL(savedSmtp.ssl === "1" || savedSmtp.ssl === true);
                setSmtpPresetId(savedSmtp.smtp_preset_id?.toString() || "0");

                // Match saved smtp_preset_id against scheduler presets
                for(let i = 0; i < servers.length; i++){
                    if(servers[i].smtpid === savedSmtp.smtp_preset_id?.toString()){
                        setSmtpPreset(i+"");
                        break;
                    }
                }
            }
        });
    }

    const onSelectSmtpOption = (option, options = smtpOptions) => {
        if(option === "-1"){
            setSmtpName("");
            setSmtpHost("");
            setSmtpUser("");
            setSmtpPass("");
            setSmtpPort("");
            setSmtpSSL(false);
            setSmtpPresetId("0");
        } else {
            const selected = options[option];
            setSmtpName(selected.smtpname || "");
            setSmtpHost(selected.smtphost || "");
            setSmtpUser("**********");
            setSmtpPass("**********");
            setSmtpPort(selected.smtpport?.toString() || "");
            setSmtpSSL(selected.sslStartMode);
            setSmtpPresetId(selected.smtpid?.toString() || "0");
        }
    }

    const validateSmtp = () => {
        setValidateSmtpLoader(true);
        let postData = {
            sft_id: props.login.sft_status,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            host: smtpHost,
            user: smtpUser,
            port: smtpPort,
            pass: smtpPass,
            ssl: smtpSSL
        }
        SftGlobalData.post('eticket&action=validateSmtp', postData).then(response => {
            props.notify(response.message, 2000, "bottom-center", props.theme, 5456886);
            setValidateSmtpLoader(false);
        });
    }

    const saveSettings = () => {
        // Save active toggles for each service type that has a record
        if(mainId) update(active, attachments, mainId);
        if(mainIdEinvoice) update(activeEinvoice, attachmentsEinvoice, mainIdEinvoice, activatedAtEinvoice);
        if(mainIdEcustom) update(activeEcustom, attachmentsEcustom, mainIdEcustom);
        // Save SMTP settings
        saveSmtpSettings();
    }

    const saveSmtpSettings = () => {
        let postData = {
            key: props.api,
            smtp_preset_id: smtpPresetId,
            name: smtpName,
            host: smtpHost,
            user: smtpUser,
            pass: smtpPass,
            port: smtpPort,
            ssl: smtpSSL
        }
        SftGlobalData.post('eticket&action=saveSmtp', postData).then(response => {
            if(response.status === 200){
                props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-right", props.theme, 1);
            }
        });
    }

    const fetchDbVersion = () => {
        SftGlobalData.post('sftData', {key: props.api, type: "dbversion"}).then(response => {
            setDbVersion(parseInt(response.data.data?.version));
        });
    }

    const fetchHeaders = () => {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api
        }

        SftGlobalData.post('eticket&action=fetch', postData).then(response => {
            if(response.status == 200){

                // Filter settings by service_type
                const responseData = response.data || [];

                let eticketData = responseData.filter(item => String(item.service_type).toLowerCase() === 'eticket' || !item?.service_type )?.[0];
                let einvoiceData = responseData.filter(item => String(item.service_type).toLowerCase() === 'invoice')?.[0];
                let ecustomData = responseData.filter(item => String(item.service_type).toLowerCase() === 'custom')?.[0];

                setMainId(eticketData?.id);
                setMainIdEinvoice(einvoiceData?.id);
                setMainIdEcustom(ecustomData?.id);
                setActive(eticketData?.active);
                setActiveEinvoice(einvoiceData?.active);
                setActiveEcustom(ecustomData?.active);
                setAttachments(eticketData?.enable_attachments);
                setAttachmentsEinvoice(einvoiceData?.enable_attachments);
                setAttachmentsEcustom(ecustomData?.enable_attachments);
                setActivatedAtEticket(eticketData?.activated_at || null);
                setActivatedAtEinvoice(einvoiceData?.activated_at || null);
                setActivatedAtEcustom(ecustomData?.activated_at || null);
                setLists(eticketData?.settings || []);
                setListsEinvoice(einvoiceData?.settings || []);
                setListsEcustom(ecustomData?.settings || []);

                if(isSftUser) fetchSmtpOptions();
            }

            setLoading(false);
            setLoadingEinvoice(false);
            setLoadingEcustom(false);
            fetchStats();
            fetchTestData();
        }).catch(() => {
            setLoading(false);
            setLoadingEinvoice(false);
            setLoadingEcustom(false);
        });
    }

    const onDeleteService = (id, element) => {
        if (window.confirm(props.t('confirm_delete_document')) === true) {
            setLoadingEinvoice(true);
            let postData = {
                sft_id: props.login.sft_id,
                sft_group: props.login.sft_group,
                login: props.login.login,
                id: id,
                element: element,
                key: props.api
            }

            SftGlobalData.post('eticket&action=delete', postData).then(response => {
                if(response.status === 200){
                    fetchHeaders();
                }
            });
        }
    }

    const visibilityChangedHandlerEinvoice = () => {
        let temp = apiRefEinvoice.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){}
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialStateEinvoice", JSON.stringify(temp), 100000);
    }

    const visibilityChangedHandlerEcustom = () => {
        let temp = apiRefEcustom.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){}
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialStateEcustom", JSON.stringify(temp), 100000);
    }

    const fetchStats = () => {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api
        }

        SftGlobalData.post('eticket&action=stats', postData).then(response => {
            if(response.status == 200){
                if(typeof response.data?.potential !== "undefined")
                    setUsageStats(response.data?.potential);
                if(typeof response.data?.storeStats !== "undefined")
                    setStoreStats(response.data?.storeStats);
                if(typeof response.data?.stores !== "undefined")
                    setStoreNames(response.data?.stores);

                setStatsLoading(false);
            }
        });
    }

    const fetchTestData = () => {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api
        }
        SftGlobalData.post('eticket&action=testData', postData).then(response => {
            if(response.status == 200){
                setTestData(response.data);
                setTestTicket(response.data?.receipt);
                //console.log("test id", response.data?.receipt);
            }
        })
    }

    const changeTestType = (value) => {
        console.log("value", value);
        try{
            switch(value){
                case "RECEIPT": 
                    setTestTicket(testData?.receipt);
                    break;
                case "CUSTOMER_ORDER": 
                    setTestTicket(testData?.cust_order);
                    break;
                case "RESERVATION": 
                    setTestTicket(testData?.reservation);
                    break;
                case "OFFER": 
                    setTestTicket(testData?.offer);
                    break;
                default:
                    break;
            }
        }catch(e){
            console.error(e);
        }
    }

    const update = (activ, attachm, id, activatedAt) => {
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            id: id,
            active: activ,
            enable_attachments: attachm
        }
        if(activatedAt !== undefined) postData.activated_at = activatedAt;
        SftGlobalData.post('eticket&action=update', postData).then(response => {

        })
    }

    const testMail = (id, element) => {
        if(active){
            setModalTitle("Send test email");
            setModalId(id);
            setModalElement(element);
            setModalContent("testmail");
            setModalOpen(true);
        } else {
            props?.notify("E-ticket needs to be active to send test mails.", 7500, "top-right", props.theme, 87645);
        }

    }

    const testMailEinvoice = (id, element) => {
        if(activeEinvoice){
            setModalTitle("Send test email");
            setModalId(id);
            setModalElement(element);
            setModalContent("testmailEinvoice");
            const corpId = element.corp_id || "00";
            setTestInvoiceType("faktuur");
            setTestInvoiceId("");
            if(corpId === "00"){
                if(corps.length === 1){
                    setTestInvoiceCorp(corps[0].id);
                    fetchLatestInvoice("faktuur", corps[0].id);
                } else {
                    setTestInvoiceCorp("");
                }
            } else {
                setTestInvoiceCorp(corpId);
                fetchLatestInvoice("faktuur", corpId);
            }
            setModalOpen(true);
        } else {
            props?.notify("E-invoice needs to be active to send test mails.", 7500, "top-right", props.theme, 87645);
        }
    }

    const fetchLatestInvoice = (type, corpId) => {
        if(!corpId || corpId === "00") return;
        let postData = {
            key: props.api,
            transaction_type: type,
            corp_id: corpId
        };
        SftGlobalData.post('eticket&action=testDataEinvoice', postData).then(response => {
            if(response.status === 200 && response.data?.invoice_id){
                setTestInvoiceId(response.data.invoice_id);
            } else {
                setTestInvoiceId("");
            }
        }).catch(() => {
            setTestInvoiceId("");
        });
    }

    const testMailCallEinvoice = () => {
        if(testEmail !== "" && testInvoiceId !== ""){
            setModalOpen(false);
            let url = SftGlobalData.baseURL_node + 'debug-call-einvoice';
            let postData = {
                client_id: testData.client_id,
                db_id: testData.db_id,
                corp_id: testInvoiceCorp,
                invoice_type: testInvoiceType,
                invoice_id: testInvoiceId,
                source: "MYSFT",
                is_test: true,
                recipient: testEmail,
                language: testTicketLanguage
            };
            axios.post(url, postData, {
                headers : {
                    'Content-Type' : 'application/json; charset=UTF-8'
                }})
            .then(response => {
                if(SftGlobalData.debug){
                    console.log('url', url);
                    console.log('PostData', postData);
                    console.log('response', response);
                }
                props.notify(response.data?.message, 7500, "top-right", props.theme, 1);
            });
        }
    }

    const testMailEcustom = (id, element) => {
        if(activeEcustom){
            setModalTitle("Send test email");
            setModalId(id);
            setModalElement(element);
            setTestEcustomSubject("");
            setTestEcustomBody("");
            setTestEcustomAttachments([]);
            setModalContent("testmailEcustom");
            setModalOpen(true);
        } else {
            props?.notify("E-custom needs to be active to send test mails.", 7500, "top-right", props.theme, 87645);
        }
    }

    const onEcustomAttachmentChange = (e) => {
        const files = Array.from(e.target.files);
        const readers = files.map(file => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    resolve({ name: file.name, data: event.target.result, type: file.type });
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(readers).then(results => {
            setTestEcustomAttachments(prev => [...prev, ...results]);
        });
    }

    const testMailCallEcustom = () => {
        if(testEmail !== "" && testEcustomSubject !== ""){
            setModalOpen(false);
            let url = SftGlobalData.baseURL_node + 'debug-call-ecustom';
            let postData = {
                client_id: testData.client_id,
                db_id: testData.db_id,
                store_id: modalElement.store_id,
                pos_id: modalElement.pos_id,
                source: "MYSFT",
                is_test: true,
                recipient: testEmail,
                language: testTicketLanguage,
                subject: testEcustomSubject,
                body: testEcustomBody,
                attachments: testEcustomAttachments
            };
            axios.post(url, postData, {
                headers : {
                    'Content-Type' : 'application/json; charset=UTF-8'
                }})
            .then(response => {
                if(SftGlobalData.debug){
                    console.log('url', url);
                    console.log('PostData', postData);
                    console.log('response', response);
                }
                props.notify(response.data?.message, 7500, "top-right", props.theme, 1);
            });
        }
    }

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedStore(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    const handleChangePos = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedPos(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const getModalContent = () => {
        switch(modalContent){
            case "duplicate":
                return  <div>
                <br/>
                <p>What is the target of the duplication?</p>
                <br/>
                <div className="rowContainerBetween" >
                    <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3, marginRight: 1 }}>
                        <InputLabel id="demo-multiple-chip-label" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>Store</InputLabel>
                        <Select
                        style={{marginBottom:10}}
                        className={props.theme+"_accent "+props.theme+"_text"}
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={selectedStore}
                        onChange={handleChange}
                        input={<OutlinedInput id="select-multiple-chip" label="Store" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} className={props.theme+"_accent_darker "+props.theme+"_text"}/>
                            ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                        >
                        {stores.map((store) => (
                            <MenuItem
                            key={store.code}
                            value={store.code+" - "+store.oms}
                            style={getStyles(store.oms, selectedStore, theme)}
                            >
                                <Checkbox checked={selectedStore.indexOf(store.code+" - "+store.oms) > -1} />
                                <ListItemText primary={store.code+" - "+store.oms}/>
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3 }}>
                        <InputLabel id="demo-multiple-chip-label-pos" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>POS</InputLabel>
                        <Select
                        className={props.theme+"_accent "+props.theme+"_text"}
                        labelId="demo-multiple-chip-label-pos"
                        id="demo-multiple-chip-pos"
                        multiple
                        value={selectedPos}
                        onChange={handleChangePos}
                        input={<OutlinedInput id="select-multiple-chip-pos" label="POS" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} className={props.theme+"_accent_darker "+props.theme+"_text"}/>
                            ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                        >
                        {pos.map((pos) => (
                            <MenuItem
                            key={pos.code}
                            value={pos.code+" - "+pos.oms}
                            style={getStyles(pos.oms, selectedPos, theme)}
                            >
                                <Checkbox checked={selectedPos.indexOf(pos.code+" - "+pos.oms) > -1} />
                                <ListItemText primary={pos.code+" - "+pos.oms}/>
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="rowContainerBetween" style={{alignItems: 'center'}}>
                    {/*<Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{duplicateCall(modalId, modalElement, 'stores')}}>&nbsp;{props.t('store')}&nbsp;</Button>
                    <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{duplicateCall(modalId, modalElement, 'pos')}}>&nbsp;{props.t('pos_id')}&nbsp;</Button>*/}
                    <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{setModalOpen(false);}}>&nbsp;{props.t('back')}&nbsp;</Button>
                    <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{duplicateCall(modalId, modalElement)}}>&nbsp;{props.t('copy')}&nbsp;</Button>
                </div>
            </div>
            case "duplicateEinvoice":
                return <div>
                <br/>
                <p>What is the target of the duplication?</p>
                <br/>
                <div className="rowContainerBetween">
                    <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3 }}>
                        <InputLabel id="corp-multiple-chip-label" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>Corp</InputLabel>
                        <Select
                        style={{marginBottom:10}}
                        className={props.theme+"_accent "+props.theme+"_text"}
                        labelId="corp-multiple-chip-label"
                        id="corp-multiple-chip"
                        multiple
                        value={selectedCorp}
                        onChange={handleChangeCorp}
                        input={<OutlinedInput id="select-multiple-chip-corp" label="Corp" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} className={props.theme+"_accent_darker "+props.theme+"_text"}/>
                            ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                        >
                        {corps.filter(corp => {
                            // Exclude corps that already have einvoice settings
                            const existingCorpIds = (listsEinvoice || []).map(s => s.corp_id);
                            return !existingCorpIds.includes(corp.id);
                        }).map((corp) => (
                            <MenuItem
                            key={corp.id}
                            value={corp.id+" - "+corp.name}
                            style={getStyles(corp.name, selectedCorp, theme)}
                            >
                                <Checkbox checked={selectedCorp.indexOf(corp.id+" - "+corp.name) > -1} />
                                <ListItemText primary={corp.id+" - "+corp.name}/>
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="rowContainerBetween" style={{alignItems: 'center'}}>
                    <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{setModalOpen(false);}}>&nbsp;{props.t('back')}&nbsp;</Button>
                    <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{duplicateCallEinvoice(modalId, modalElement)}}>&nbsp;{props.t('copy')}&nbsp;</Button>
                </div>
            </div>
            case "testmail":
                return <div className="" style={{width: '100%', textAlign: 'left'}} >
                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <FormControl className={props.theme+ '_accent _100perc margin_right__10px'}>
                      <InputLabel id="demo-simple-select-label">Transaction type</InputLabel>
                      <Select
                        className={props.theme+"_accent "+props.theme+"_text _100perc"}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={testTicketType}
                        label="Transaction type"
                        onChange={(event)=>{const {target: { value },} = event; setTestTicketType(value); changeTestType(value);}}
                        style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            <MenuItem value={"CUSTOMER_ORDER"}>Customer order</MenuItem>
                            {/*<MenuItem value={"OFFER"}>Offer</MenuItem>*/}
                            <MenuItem value={"RECEIPT"}>Receipt</MenuItem>
                            <MenuItem value={"RESERVATION"}>Reservation</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                        minRows={1}
                        autoComplete="off" 
                        className={props.theme+ '_accent _100perc'}
                        required
                        id="testTicket"
                        label={"Transaction ID"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.light_text
                              },
                            '& .MuiInputLabel-root': {
                                color: Colors.light_text
                             }, borderRadius: 3, marginTop: 0} 
                            :
                            {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.dark_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.dark_text_accent
                                }, borderRadius: 3, marginTop: 0}}
                        value={testTicket}
                        onChange={(event)=>{setTestTicket(event.target.value)}}
                        />  
                </div>

                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <TextField
                        minRows={1}
                        autoComplete="off" 
                        className={props.theme+ '_accent _100perc margin_right__10px'}
                        required
                        id="testTicketMail"
                        label={"Recipient email"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.light_text
                              },
                            '& .MuiInputLabel-root': {
                                color: Colors.light_text
                             }, borderRadius: 3, marginTop: 0} 
                            :
                            {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.dark_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.dark_text_accent
                                }, borderRadius: 3, marginTop: 0}}
                        value={testEmail}
                        onChange={(event)=>{setTestEmail(event.target.value)}}
                    />
                    <div className="rowContainerStart" style={{width: '100%', alignItems: 'center'}}>
                        <FormControl className={props.theme+ '_accent _100perc margin_right__10px'}>
                            <InputLabel id="demo-simple-select-label">Email language</InputLabel>
                            <Select
                                className={props.theme+"_accent "+props.theme+"_text _100perc"}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={testTicketLanguage}
                                label="Email language"
                                onChange={(event)=>{const {target: { value },} = event; setTestTicketLanguage(value);}}
                                style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                                    <MenuItem value={"NL"}>NL</MenuItem>
                                    <MenuItem value={"FR"}>FR</MenuItem>
                                    <MenuItem value={"EN"}>EN</MenuItem>
                            </Select>
                        </FormControl>
                        <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{testMailCall(modalElement)}}>&nbsp;{props.t('send')}&nbsp;</Button>
                    </div>
                </div>

                <Button type="button" className={"button_container__button_no_margin _100perc maxHeight "} onClick={()=>{setModalOpen(false);}}>&nbsp;{props.t('back')}&nbsp;</Button>
            </div>
            case "testmailEinvoice":
                return <div className="" style={{width: '100%', textAlign: 'left'}} >
                {modalElement?.corp_id === "00" && (
                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <FormControl className={props.theme+ '_accent _100perc'}>
                      <InputLabel id="test-corp-label">Corp</InputLabel>
                      <Select
                        className={props.theme+"_accent "+props.theme+"_text _100perc"}
                        labelId="test-corp-label"
                        id="test-corp-select"
                        value={testInvoiceCorp}
                        label="Corp"
                        onChange={(event)=>{const val = event.target.value; setTestInvoiceCorp(val); setTestInvoiceId(""); fetchLatestInvoice(testInvoiceType, val);}}
                        style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            {corps.map((corp) => (
                                <MenuItem key={corp.id} value={corp.id}>
                                    {corp.id} - {corp.name}
                                </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                </div>
                )}

                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <FormControl className={props.theme+ '_accent _100perc margin_right__10px'}>
                      <InputLabel id="invoice-type-label">Invoice type</InputLabel>
                      <Select
                        className={props.theme+"_accent "+props.theme+"_text _100perc"}
                        labelId="invoice-type-label"
                        id="invoice-type-select"
                        value={testInvoiceType}
                        label="Invoice type"
                        disabled={modalElement?.corp_id === "00" && !testInvoiceCorp}
                        onChange={(event)=>{const val = event.target.value; setTestInvoiceType(val); if(testInvoiceCorp) fetchLatestInvoice(val, testInvoiceCorp);}}
                        style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            <MenuItem value={"faktuur"}>Faktuur</MenuItem>
                            <MenuItem value={"b2binvoice"}>B2B Invoice</MenuItem>
                            <MenuItem value={"b2bcreditnote"}>B2B Credit Note</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc'}
                        required
                        id="testInvoiceId"
                        label={"Invoice ID"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.light_text
                              },
                            '& .MuiInputLabel-root': {
                                color: Colors.light_text
                             }, borderRadius: 3, marginTop: 0}
                            :
                            {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.dark_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.dark_text_accent
                                }, borderRadius: 3, marginTop: 0}}
                        value={testInvoiceId}
                        onChange={(event)=>{setTestInvoiceId(event.target.value)}}
                        />
                </div>

                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_right__10px'}
                        required
                        id="testInvoiceMail"
                        label={"Recipient email"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.light_text
                              },
                            '& .MuiInputLabel-root': {
                                color: Colors.light_text
                             }, borderRadius: 3, marginTop: 0}
                            :
                            {
                            '& .MuiOutlinedInput-input': {
                                color: Colors.dark_text
                                },
                                '& .MuiInputLabel-root': {
                                    color: Colors.dark_text_accent
                                }, borderRadius: 3, marginTop: 0}}
                        value={testEmail}
                        onChange={(event)=>{setTestEmail(event.target.value)}}
                    />
                    <div className="rowContainerStart" style={{width: '100%', alignItems: 'center'}}>
                        <FormControl className={props.theme+ '_accent _100perc margin_right__10px'}>
                            <InputLabel id="invoice-lang-label">Email language</InputLabel>
                            <Select
                                className={props.theme+"_accent "+props.theme+"_text _100perc"}
                                labelId="invoice-lang-label"
                                id="invoice-lang-select"
                                value={testTicketLanguage}
                                label="Email language"
                                onChange={(event)=>{const {target: { value },} = event; setTestTicketLanguage(value);}}
                                style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                                    <MenuItem value={"NL"}>NL</MenuItem>
                                    <MenuItem value={"FR"}>FR</MenuItem>
                                    <MenuItem value={"EN"}>EN</MenuItem>
                            </Select>
                        </FormControl>
                        <Button type="button" disabled={!testInvoiceId || !testEmail} className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{testMailCallEinvoice()}}>&nbsp;{props.t('send')}&nbsp;</Button>
                    </div>
                </div>

                <Button type="button" className={"button_container__button_no_margin _100perc maxHeight "} onClick={()=>{setModalOpen(false);}}>&nbsp;{props.t('back')}&nbsp;</Button>
            </div>
            case "testmailEcustom":
                return <div className="" style={{width: '100%', textAlign: 'left'}} >

                <TextField
                    minRows={1}
                    autoComplete="off"
                    className={props.theme+ '_accent _100perc margin_bottom_10px'}
                    required
                    id="testEcustomSubject"
                    label={props.t('subject')}
                    size={'small'}
                    sx={(props.theme==='light') ? {
                        '& .MuiOutlinedInput-input': { color: Colors.light_text },
                        '& .MuiInputLabel-root': { color: Colors.light_text }, borderRadius: 3, marginTop: 0}
                        : {
                        '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                        '& .MuiInputLabel-root': { color: Colors.dark_text_accent }, borderRadius: 3, marginTop: 0}}
                    value={testEcustomSubject}
                    onChange={(event)=>{setTestEcustomSubject(event.target.value)}}
                />

                <TextField
                    multiline
                    rows={6}
                    autoComplete="off"
                    className={props.theme+ '_accent _100perc margin_bottom_10px'}
                    id="testEcustomBody"
                    label={props.t('message')}
                    size={'small'}
                    sx={(props.theme==='light') ? {
                        '& .MuiOutlinedInput-input': { color: Colors.light_text },
                        '& .MuiInputLabel-root': { color: Colors.light_text }, borderRadius: 3, marginTop: 0}
                        : {
                        '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                        '& .MuiInputLabel-root': { color: Colors.dark_text_accent }, borderRadius: 3, marginTop: 0}}
                    value={testEcustomBody}
                    onChange={(event)=>{setTestEcustomBody(event.target.value)}}
                />

                <div className="margin_bottom_10px">
                    <label className="text-white" style={{fontSize: 13, marginBottom: 4, display: 'block'}}>{props.t('attachments')} ({props.t('optional')})</label>
                    <input type="file" multiple onChange={onEcustomAttachmentChange} />
                    {testEcustomAttachments.length > 0 && (
                        <div style={{marginTop: 8}}>
                            {testEcustomAttachments.map((att, index) => (
                                <div key={index} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4}}>
                                    <span style={{fontSize: 13}}>{att.name}</span>
                                    <Button size="small" style={{minWidth: 'auto', padding: '2px 6px', color: Colors.def_red}} onClick={() => {
                                        setTestEcustomAttachments(prev => prev.filter((_, i) => i !== index));
                                    }}>✕</Button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="rowContainerBetween alignCenterInContainer margin_bottom_10px">
                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_right__10px'}
                        required
                        id="testEcustomMail"
                        label={"Recipient email"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text }, borderRadius: 3, marginTop: 0}
                            : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent }, borderRadius: 3, marginTop: 0}}
                        value={testEmail}
                        onChange={(event)=>{setTestEmail(event.target.value)}}
                    />
                    <FormControl className={props.theme+ '_accent'} style={{minWidth: 100}}>
                        <InputLabel id="ecustom-lang-label">Language</InputLabel>
                        <Select
                            className={props.theme+"_accent "+props.theme+"_text"}
                            labelId="ecustom-lang-label"
                            value={testTicketLanguage}
                            label="Language"
                            onChange={(event)=>{setTestTicketLanguage(event.target.value);}}
                            style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                                <MenuItem value={"NL"}>NL</MenuItem>
                                <MenuItem value={"FR"}>FR</MenuItem>
                                <MenuItem value={"EN"}>EN</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="rowContainerBetween alignCenterInContainer">
                    <Button type="button" disabled={!testEcustomSubject || !testEmail} className={"button_container__button_no_margin _100perc maxHeight "} onClick={()=>{testMailCallEcustom()}}>&nbsp;{props.t('send')}&nbsp;</Button>
                </div>

                <Button type="button" className={"button_container__button_no_margin _100perc maxHeight margin_top_10px"} onClick={()=>{setModalOpen(false);}}>&nbsp;{props.t('back')}&nbsp;</Button>
            </div>
            default:
                return <div></div>
        }
    }


    const testMailCall = () => {
        
        if(testEmail !== "" && testTicket !== ""){
            setModalOpen(false);
            let url = SftGlobalData.baseURL_node + 'debug-call';
            let postData = {
                client_id: testData.client_id,
                db_id: testData.db_id,
                store_id: modalElement.store_id,
                pos_id: modalElement.pos_id,
                transaction_type: testTicketType,
                transaction_id: testTicket,
                source: "MYSFT",
                is_test: true,
                recipient: testEmail,
                language: testTicketLanguage
                };
            axios.post(url, postData, {
                headers : {
                    'Content-Type' : 'application/json; charset=UTF-8'
                }})
            .then(response => {
                if(SftGlobalData.debug){
                    console.log('url', url);
                    console.log('PostData', postData);
                    console.log('response', response);
                }
                props.notify(response.data?.message, 7500, "top-right", props.theme, 1); 
            });
        }
    }

    const getUsageChart = () => {
        if(usageStats.length === 0){
            return <div></div>
        } else {
            const maxPotential = Math.max(...usageStats.map(stat => parseFloat(stat.potential)));
            const roundedMaxPotential = Math.ceil((maxPotential + 1000) / 1000) * 1000;

            return (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart width={500} height={300} margin={{top: 5, right: 30, left: 20, bottom: 5,}} data={usageStats}>
                  <Legend verticalAlign="top" height={36}/>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month_name" />
                  <YAxis domain={[0, roundedMaxPotential]}  />
                  <Tooltip />
                  <Line type="monotone" dataKey="potential" name={props.t('potential')} stroke="#2196f3" activeDot={{ r: 8 }}/>
                  <Line type="monotone" dataKey="sent" name={props.t('sent')} stroke="#800000" activeDot={{ r: 8 }}/>
                </LineChart>
              </ResponsiveContainer>
            )
        }
    }

    const getStoreChart = () => {
        if(storeStats.length === 0 || storeNames.length === 0){
            return <div></div>
        } else {
            return (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart width={500} height={300} margin={{top: 5,right: 30,left: 20,bottom: 5,}} data={storeStats}>
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="month_name" />
                      <YAxis />
                      <Tooltip />
                      {storeNames.map((store, index) => <Bar stackId="a" dataKey={store} fill={SftGlobalData.colors[index]} key={index}/>)}
                  </BarChart>
                </ResponsiveContainer>
              )
        }
    }

    return (
        <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme}>
            {isSftUser && value === 0 && <FloatingSaveButton onClick={() => { saveSettings(); }} />}
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalOpen}
                onClose={()=>{setModalOpen(false);}}
                BackdropComponent={Backdrop}
                >
                <Box sx={style} style={{minWidth: 500}} className={props.theme + "_forced _50perc"}>
                    <p className={"primary_border_bottom text_center margin_top_none margin_bottom_15px bold "} style={{fontWeight: 1200}}>{modalTitle}</p>
                    <div>
                        {modalContent !== "" && getModalContent()}
                    </div>
                </Box>
            </StyledModal>
            
            <div className={"container_list__title " + props.theme}>
                <h2>{props.t('eservices')}</h2>
                {(dbVersion < 319) && <p className='error_text'>Database update required.	&#40;current: {dbVersion}, required: 319&#41;</p>}
            </div>
            <br/><br/><br/><br/>
            <Box className={props.theme + ' _100perc'}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                  <Tabs value={value} onChange={handleChangeTab} className={props.theme} variant="scrollable" scrollButtons="auto">
                    {isSftUser && <Tab label={props.t('settings') + " "} {...a11yProps(0)} className={props.theme}/>}
                    <Tab label={"E-ticket "} {...a11yProps(isSftUser ? 1 : 0)} className={props.theme}/>
                    {isSftUser && <Tab label={"E-invoice "} {...a11yProps(2)} className={props.theme}/>}
                    {isSftUser && <Tab label={"E-custom "} {...a11yProps(3)} className={props.theme}/>}
                    <Tab label={props.t('statistics') + " "} {...a11yProps(isSftUser ? 4 : 1)} className={props.theme}/>
                  </Tabs>
              </Box>

              {/* Settings Tab - SFT only */}
              {isSftUser && (
                <TabPanel value={value} index={0}>
                  <div className="rowContainerEvenly" style={{width: '100%'}}>
                    {/* Left column - Active toggles */}
                    <div className='margin_top_10px' style={{width: '45%', display: 'flex', flexDirection: 'column'}}>
                      <h4>Active</h4>
                      <hr/>
                      <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <div style={{marginLeft: 5, flex: 1}}>E-ticket</div>
                        <MuiTooltip title={!mainId ? props.t('eservice_open_global_first') : ""} placement="left">
                          <span>
                            <Switch
                              checked={active}
                              disabled={!mainId}
                              onChange={(event) => { setActive(event.target.checked); }}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </span>
                        </MuiTooltip>
                      </div>
                      <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <div style={{marginLeft: 5, flex: 1}}>E-invoice</div>
                        <MuiTooltip title={!mainIdEinvoice ? props.t('eservice_open_global_first') : ""} placement="left">
                          <span>
                            <Switch
                              checked={activeEinvoice}
                              disabled={!mainIdEinvoice}
                              onChange={(event) => { setActiveEinvoice(event.target.checked); }}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </span>
                        </MuiTooltip>
                      </div>
                      <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <div style={{marginLeft: 5, flex: 1}}>E-custom</div>
                        <MuiTooltip title={!mainIdEcustom ? props.t('eservice_open_global_first') : ""} placement="left">
                          <span>
                            <Switch
                              checked={activeEcustom}
                              disabled={!mainIdEcustom}
                              onChange={(event) => { setActiveEcustom(event.target.checked); }}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </span>
                        </MuiTooltip>
                      </div>
                      {activeEinvoice && mainIdEinvoice && <div style={{marginTop: 190}}>
                        <hr style={{borderColor: '#e5e7eb'}}/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label={props.t('start_sync_from') + ' (E-invoice)'}
                            value={activatedAtEinvoice ? dayjs(activatedAtEinvoice) : null}
                            onChange={(newValue) => { setActivatedAtEinvoice(newValue ? newValue.format('YYYY-MM-DD HH:mm:ss') : null); }}
                            slotProps={{ textField: { size: 'small', style: { width: '100%' }, variant: 'outlined', InputLabelProps: { shrink: true } } }}
                            format="DD/MM/YYYY"
                          />
                        </LocalizationProvider>
                      </div>}
                    </div>

                    {/* Right column - SMTP settings */}
                    <div className='margin_top_10px' style={{width: '45%', display: 'flex', flexDirection: 'column'}}>
                      <h4>SMTP {props.t('settings')}</h4>
                      <hr/>
                      <FormControl className={props.theme+ '_accent _100perc margin_top_10px'}>
                        <InputLabel id="smtp-preset-label">Preset</InputLabel>
                        <Select
                          className={props.theme+"_accent "+props.theme+"_text _100perc"}
                          labelId="smtp-preset-label"
                          id="smtp-preset-select"
                          value={smtpPreset}
                          label="SMTP preset"
                          onChange={(event) => { const { target: { value } } = event; setSmtpPreset(value); onSelectSmtpOption(value); }}
                          style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            <MenuItem value={"-1"}>---</MenuItem>
                            {smtpOptions.map((row, index) => (
                              <MenuItem key={index} value={index}>
                                {row.smtpid} - {row.smtpname}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      <TextField
                        disabled={smtpPreset !== "-1"}
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_top_10px'}
                        id="smtp_name"
                        label={"SMTP name"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                          '& .MuiOutlinedInput-input': { color: Colors.light_text },
                          '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                          borderRadius: 3, marginTop: 0
                        } : {
                          '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                          '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                          borderRadius: 3, marginTop: 0
                        }}
                        value={smtpName}
                        onChange={(event) => { setSmtpName(event.target.value) }}
                      />
                      <TextField
                        disabled={smtpPreset !== "-1"}
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_top_10px'}
                        id="smtp_host"
                        label={"SMTP host"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                          '& .MuiOutlinedInput-input': { color: Colors.light_text },
                          '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                          borderRadius: 3, marginTop: 0
                        } : {
                          '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                          '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                          borderRadius: 3, marginTop: 0
                        }}
                        value={smtpHost}
                        onChange={(event) => { setSmtpHost(event.target.value) }}
                      />
                      <TextField
                        disabled={smtpPreset !== "-1"}
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_top_10px'}
                        id="smtp_port"
                        label={"SMTP port"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                          '& .MuiOutlinedInput-input': { color: Colors.light_text },
                          '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                          borderRadius: 3, marginTop: 0
                        } : {
                          '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                          '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                          borderRadius: 3, marginTop: 0
                        }}
                        value={smtpPort}
                        onChange={(event) => { setSmtpPort(event.target.value) }}
                      />
                      <TextField
                        disabled={smtpPreset !== "-1"}
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_top_10px'}
                        id="smtp_user"
                        label={"SMTP username"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                          '& .MuiOutlinedInput-input': { color: Colors.light_text },
                          '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                          borderRadius: 3, marginTop: 0
                        } : {
                          '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                          '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                          borderRadius: 3, marginTop: 0
                        }}
                        value={smtpUser}
                        onChange={(event) => { setSmtpUser(event.target.value) }}
                      />
                      <TextField
                        disabled={smtpPreset !== "-1"}
                        minRows={1}
                        autoComplete="off"
                        className={props.theme+ '_accent _100perc margin_top_10px'}
                        id="smtp_pass"
                        label={"SMTP password"}
                        size={'small'}
                        type={showSmtpPass ? "text" : "password"}
                        sx={(props.theme==='light') ? {
                          '& .MuiOutlinedInput-input': { color: Colors.light_text },
                          '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                          borderRadius: 3, marginTop: 0
                        } : {
                          '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                          '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                          borderRadius: 3, marginTop: 0
                        }}
                        value={smtpPass}
                        onChange={(event) => { setSmtpPass(event.target.value) }}
                        InputProps={smtpPreset === "-1" ? {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowSmtpPass(!showSmtpPass)}
                                edge="end"
                                size="small"
                              >
                                {showSmtpPass ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        } : {}}
                      />
                      <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <div style={{marginLeft: 5}}>SSL</div>
                        <Switch
                          disabled={smtpPreset !== "-1"}
                          checked={smtpSSL}
                          onChange={(event) => { setSmtpSSL(event.target.checked) }}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>
                      {smtpPreset === "-1" && <Button
                          loading={validateSmtpLoader}
                          type="button"
                          className='login__button _100perc'
                          size="large"
                          onClick={() => { validateSmtp() }}>&nbsp;Test connection&nbsp;</Button>}
                    </div>
                  </div>
                </TabPanel>
              )}

              {/* E-ticket Tab */}
              <TabPanel value={value} index={isSftUser ? 1 : 0}>
                    {(props.login.sft_status == "0" && !active) && (
                        <div style={{ margin: "2rem 0", textAlign: "center" }}>
                            {lists?.length > 0 ? (
                                <p>{props.t('eticket_awaiting_activation')}</p>
                            ) : (
                                <Button onClick={() => navigate("/" + props.lang + "/eticket-wizard")}>
                                {props.t('eticket_request')}
                                </Button>
                            )}
                        </div>
                    )}
                  <div className='rowContainerCenter _100perc'>
                    {((typeof lists !== "undefined" && lists?.length > 0) || defaultEticket) && <DataGridPro
                      apiRef={apiRef}
                      initialState={initialGrid}
                      className={'manuals_application_headers ' + props.theme}
                      columns={gridColumns}
                      rows={lists?.length > 0
                          ? lists.map((row, index) => {return {
                              id: row.key,
                              mainId: mainId,
                              key: row.key,
                              lang: props.lang,
                              theme: props.theme,
                              name: row.name,
                              store_id: row.store_id,
                              pos_id: row.pos_id,
                              edit: "Edit",
                              delete: "Delete",
                              copy: "Copy",
                              active: row.active,
                              listSize: lists.length,
                              isSimulated: false
                          }})
                          : (defaultEticket ? [{
                              id: 'simulated_eticket',
                              mainId: defaultEticket.id,
                              key: defaultEticket.key,
                              lang: props.lang,
                              theme: props.theme,
                              name: defaultEticket.name,
                              store_id: defaultEticket.store_id,
                              pos_id: defaultEticket.pos_id,
                              edit: "Edit",
                              delete: "Delete",
                              copy: "Copy",
                              active: false,
                              listSize: 1,
                              isSimulated: true
                          }] : [])
                      }
                      onColumnWidthChange={()=>{visibilityChangedHandler();}}
                      onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                      onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                      rowThreshold={0}
                      rowHeight={38}
                      height={300}
                      loading={loading}
                      pagination={false}
                      /> }
                    {(typeof lists === "undefined" || lists?.length === 0) && !defaultEticket && props.login.sft_status != "0" && <Button onClick={()=>{navigate("/"+props.lang+"/eticket-wizard");}}><img className='scale-up-center' src={WizardIcon} width="48px" alt={"Wizard"} /></Button>}
                </div>
              </TabPanel>

              {/* E-invoice Tab */}
              {isSftUser && <TabPanel value={value} index={2}>
                <div className='rowContainerCenter _100perc'>
                  {((typeof listsEinvoice !== "undefined" && listsEinvoice?.length > 0) || defaultEinvoice) && <DataGridPro
                    apiRef={apiRefEinvoice}
                    initialState={initialGridEinvoice}
                    className={'manuals_application_headers ' + props.theme}
                    columns={gridColumnsEinvoice}
                    rows={listsEinvoice?.length > 0
                        ? listsEinvoice.map((row, index) => {return {
                            id: row.key,
                            mainIdEinvoice: mainIdEinvoice,
                            key: row.key,
                            lang: props.lang,
                            theme: props.theme,
                            name: row.name,
                            corp_id: row.corp_id,
                            edit: "Edit",
                            delete: "Delete",
                            active: row.active,
                            listSize: listsEinvoice.length,
                            isSimulated: false
                        }})
                        : (defaultEinvoice ? [{
                            id: 'simulated_einvoice',
                            mainIdEinvoice: defaultEinvoice.id,
                            key: defaultEinvoice.key,
                            lang: props.lang,
                            theme: props.theme,
                            name: defaultEinvoice.name,
                            corp_id: defaultEinvoice.corp_id,
                            edit: "Edit",
                            delete: "Delete",
                            active: false,
                            listSize: 1,
                            isSimulated: true
                        }] : [])
                    }
                    onColumnWidthChange={()=>{visibilityChangedHandlerEinvoice();}}
                    onColumnVisibilityModelChange={()=>{visibilityChangedHandlerEinvoice();}}
                    onPreferencePanelClose={()=>{visibilityChangedHandlerEinvoice();}}
                    rowThreshold={0}
                    rowHeight={38}
                    height={300}
                    loading={loadingEinvoice}
                    pagination={false}
                  />}
                  {(typeof listsEinvoice === "undefined" || listsEinvoice?.length === 0) && !defaultEinvoice && !loadingEinvoice &&
                    <p style={{textAlign: 'center', padding: '20px'}}>{props.t('no_data')}</p>
                  }
                  {loadingEinvoice &&
                    <TailSpin
                      height="40"
                      width="40"
                      color={Colors.sft_blue}
                      ariaLabel='loading'
                    />
                  }
                </div>
              </TabPanel>}

              {/* E-custom Tab */}
              {isSftUser && <TabPanel value={value} index={3}>
                <div className='rowContainerCenter _100perc'>
                  {((typeof listsEcustom !== "undefined" && listsEcustom?.length > 0) || defaultEcustom) && <DataGridPro
                    apiRef={apiRefEcustom}
                    initialState={initialGridEcustom}
                    className={'manuals_application_headers ' + props.theme}
                    columns={gridColumnsEcustom}
                    rows={listsEcustom?.length > 0
                        ? listsEcustom.map((row, index) => {return {
                            id: row.key,
                            mainIdEcustom: mainIdEcustom,
                            key: row.key,
                            lang: props.lang,
                            theme: props.theme,
                            name: row.name,
                            store_id: row.store_id,
                            pos_id: row.pos_id,
                            edit: "Edit",
                            delete: "Delete",
                            active: row.active,
                            listSize: listsEcustom.length,
                            isSimulated: false
                        }})
                        : (defaultEcustom ? [{
                            id: 'simulated_ecustom',
                            mainIdEcustom: defaultEcustom.id,
                            key: defaultEcustom.key,
                            lang: props.lang,
                            theme: props.theme,
                            name: defaultEcustom.name,
                            store_id: defaultEcustom.store_id,
                            pos_id: defaultEcustom.pos_id,
                            edit: "Edit",
                            delete: "Delete",
                            active: false,
                            listSize: 1,
                            isSimulated: true
                        }] : [])
                    }
                    onColumnWidthChange={()=>{visibilityChangedHandlerEcustom();}}
                    onColumnVisibilityModelChange={()=>{visibilityChangedHandlerEcustom();}}
                    onPreferencePanelClose={()=>{visibilityChangedHandlerEcustom();}}
                    rowThreshold={0}
                    rowHeight={38}
                    height={300}
                    loading={loadingEcustom}
                    pagination={false}
                  />}
                  {(typeof listsEcustom === "undefined" || listsEcustom?.length === 0) && !defaultEcustom && !loadingEcustom &&
                    <p style={{textAlign: 'center', padding: '20px'}}>{props.t('no_data')}</p>
                  }
                  {loadingEcustom &&
                    <TailSpin
                      height="40"
                      width="40"
                      color={Colors.sft_blue}
                      ariaLabel='loading'
                    />
                  }
                </div>
              </TabPanel>}

              {/* Stats Tab */}
              <TabPanel value={value} index={isSftUser ? 4 : 1}>
                <div className='columnContainerStart _100perc'>
                    <hr/>
                    <h4 style={{marginTop: 5}}>{props.t('eticket_usage')}</h4>
                    <hr/>
                    {statsLoading && <div className={"container_list__title " + props.theme} style={{display:"flex", justifyContent: "space-evenly", marginTop: 5, border: 1}}>
                        <TailSpin
                            height="40"
                            width="40"
                            color={Colors.sft_blue}
                            ariaLabel='loading'
                        />
                    </div>}
                    {!statsLoading && getUsageChart()}
                    {usageStats.length === 0 && <p style={{textAlign: "center"}}>{props.t('no_data')}</p>}
                    <hr/>
                    <h4 style={{marginTop: 5}}>{props.t('eticket_store_usage')}</h4>
                    <hr/>
                    {statsLoading && <div className={"container_list__title " + props.theme} style={{display:"flex", justifyContent: "space-evenly", marginTop: 5, border: 1}}>
                        <TailSpin
                            height="40"
                            width="40"
                            color={Colors.sft_blue}
                            ariaLabel='loading'
                        />
                    </div>}
                    {(storeStats?.length > 0 && storeNames?.length > 0 && !statsLoading) && getStoreChart()}
                    {(storeStats?.length === 0 || storeNames?.length === 0) && <p style={{textAlign: "center"}}>{props.t('no_data')}</p>}
                </div>
              </TabPanel>
            </Box>
        </div>

        
    );
}

export default EticketScreen;
